import { TableColumnItem, TableColumnTypeEnum } from '@ui-lib/components';

export const AGENTS_TABLE_COLUMNS: TableColumnItem[] = [
  {
    propName: 'name',
    captionTranslateKey: 'monitoring.agents.table.columns.name',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'facilityName',
    captionTranslateKey: 'monitoring.agents.table.columns.facility',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'statusName',
    captionTranslateKey: 'monitoring.agents.table.columns.status',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'comment',
    captionTranslateKey: 'monitoring.agents.table.columns.comment',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'actions',
    captionTranslateKey: 'monitoring.agents.table.columns.actions',
    type: TableColumnTypeEnum.Actions,
  },
];
